import { FaSortAmountDown, FaSortAmountDownAlt } from 'react-icons/fa';

/**
 * Renders sort icon based on current sort column and direction
 * @param {string} column - The column key to check
 * @param {string} sortBy - Current sort column
 * @param {string} sortOrder - Current sort order ('ASC' or 'DESC')
 * @returns {JSX.Element} Sort icon component
 */
export const renderSortIcon = (column, sortBy, sortOrder) => {
  if (sortBy !== column) {
    return <span className="ml-1 text-[#999] text-[13px] align-middle">⇅</span>;
  }
  
  return sortOrder === 'ASC' 
    ? <FaSortAmountDownAlt className="ml-1 text-gray-700 inline text-sm" />
    : <FaSortAmountDown className="ml-1 text-gray-700 inline text-sm" />;
};

/**
 * Alternative simple text-based sort indicator
 * @param {string} column - The column key to check
 * @param {string} sortBy - Current sort column
 * @param {string} sortOrder - Current sort order ('ASC' or 'DESC')
 * @returns {string} Sort indicator text
 */
export const getSortIndicator = (column, sortBy, sortOrder) => {
  if (sortBy !== column) return '↕';
  return sortOrder === 'ASC' ? '↑' : '↓';
};
